// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shop-container {
    display: flex;
    flex-direction: column;
    gap: 48px;
    max-width: 1024px;
    margin: 0 auto;
}

.shop-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    align-items: center;
    position: relative;
}

.shop-tabs-container {
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: center;
    width: 100%;
    margin-bottom: 16px;
    padding: 0 16px;
}

.shop-tab-item {
    display: flex;
    align-items: center;
    gap: 8px;
    box-sizing: border-box;
    padding: 8px 16px;
    cursor: pointer;
    text-decoration: none;
    color: #add8e6;
    transition: all 0.2s ease;
    border-radius: 4px;
    background: rgba(173, 216, 230, 0.1);
    border: 1px solid transparent;
    font-family: 'Kim', sans-serif;
}

.shop-tab-item:hover {
    transform: translateY(-2px);
    color: #e0f2ff;
    background: rgba(173, 216, 230, 0.2);
}

.shop-tab-item.active {
    color: #e0f2ff;
    background: rgba(173, 216, 230, 0.2);
    border-color: rgba(173, 216, 230, 0.5);
    box-shadow: 0 0 12px rgba(173, 216, 230, 0.3);
}

.shop-tab-item img {
    width: 24px;
    height: 24px;
    opacity: 0.7;
    transition: opacity 0.2s ease;
}

.shop-tab-item:hover img,
.shop-tab-item.active img {
    opacity: 1;
}

.shop-tab-label {
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.shop-items-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    max-width: 1024px;
    width: 100%;
    overflow-y: auto;
    margin: 0 auto;
    padding: 0 16px;
}

.shop-portrait {
    width: 32px;
    height: 32px;
    margin: 10px;
}

.equipment-sections {
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
}

.equipment-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 16px;
    width: 100%;
}

.equipment-type-title {
    color: #e0f2ff;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 8px 16px;
    margin-bottom: 8px;
    background: linear-gradient(90deg, rgba(173, 216, 230, 0.3), transparent);
    border-left: 4px solid #add8e6;
    text-shadow: 0 0 10px rgba(173, 216, 230, 0.5);
    letter-spacing: 1px;
    position: relative;
    font-family: 'Kim', sans-serif;
}

.equipment-type-title::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    height: 1px;
    width: 60%;
    background: linear-gradient(90deg, rgba(173, 216, 230, 0.5), transparent);
}

.equipment-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    width: 100%;
}

.shop-items-container.equipment-view {
    display: block;
}


.shop-tab-item.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: all;
}

.spells-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
}

.spells-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    width: 100%;
}

.spells-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 16px;
    width: 100%;
    margin-bottom: 32px;
}

.spells-type-title {
    color: #e0f2ff;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 8px 16px;
    margin-bottom: 8px;
    background: linear-gradient(90deg, rgba(173, 216, 230, 0.3), transparent);
    border-left: 4px solid #add8e6;
    text-shadow: 0 0 10px rgba(173, 216, 230, 0.5);
    letter-spacing: 1px;
    position: relative;
    font-family: 'Kim', sans-serif;
}

.spells-type-title::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    height: 1px;
    width: 60%;
    background: linear-gradient(90deg, rgba(173, 216, 230, 0.5), transparent);
}

.locked-spells-notice {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 24px;
    background: rgba(173, 216, 230, 0.1);
    border: 1px solid rgba(173, 216, 230, 0.2);
    border-radius: 8px;
    margin-top: 16px;
    text-align: center;
}

.locked-spells-notice img {
    width: 32px;
    height: 32px;
    opacity: 0.7;
}

.locked-spells-notice h3 {
    color: #e0f2ff;
    font-size: 18px;
    margin: 0;
}

.locked-spells-notice p {
    color: #add8e6;
    font-size: 20px;
    margin: 0;
    line-height: 1.5;
}

.consumables-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
}

.consumables-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    width: 100%;
}

.consumables-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 0 16px;
    width: 100%;
    margin-bottom: 32px;
}

.consumables-type-title {
    color: #e0f2ff;
    font-size: 20px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 8px 16px;
    margin-bottom: 8px;
    background: linear-gradient(90deg, rgba(173, 216, 230, 0.3), transparent);
    border-left: 4px solid #add8e6;
    text-shadow: 0 0 10px rgba(173, 216, 230, 0.5);
    letter-spacing: 1px;
    position: relative;
    font-family: 'Kim', sans-serif;
}

.consumables-type-title::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    height: 1px;
    width: 60%;
    background: linear-gradient(90deg, rgba(173, 216, 230, 0.5), transparent);
}`, "",{"version":3,"sources":["webpack://./src/components/shopContent/ShopContent.style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;IACtB,iBAAiB;IACjB,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;IACpC,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,sCAAsC;IACtC,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,6BAA6B;AACjC;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,yEAAyE;IACzE,8BAA8B;IAC9B,8CAA8C;IAC9C,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,UAAU;IACV,yEAAyE;AAC7E;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,yEAAyE;IACzE,8BAA8B;IAC9B,8CAA8C;IAC9C,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,UAAU;IACV,yEAAyE;AAC7E;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,oCAAoC;IACpC,0CAA0C;IAC1C,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,yEAAyE;IACzE,8BAA8B;IAC9B,8CAA8C;IAC9C,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,UAAU;IACV,yEAAyE;AAC7E","sourcesContent":[".shop-container {\n    display: flex;\n    flex-direction: column;\n    gap: 48px;\n    max-width: 1024px;\n    margin: 0 auto;\n}\n\n.shop-content {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    width: 100%;\n    align-items: center;\n    position: relative;\n}\n\n.shop-tabs-container {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    justify-content: center;\n    width: 100%;\n    margin-bottom: 16px;\n    padding: 0 16px;\n}\n\n.shop-tab-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    box-sizing: border-box;\n    padding: 8px 16px;\n    cursor: pointer;\n    text-decoration: none;\n    color: #add8e6;\n    transition: all 0.2s ease;\n    border-radius: 4px;\n    background: rgba(173, 216, 230, 0.1);\n    border: 1px solid transparent;\n    font-family: 'Kim', sans-serif;\n}\n\n.shop-tab-item:hover {\n    transform: translateY(-2px);\n    color: #e0f2ff;\n    background: rgba(173, 216, 230, 0.2);\n}\n\n.shop-tab-item.active {\n    color: #e0f2ff;\n    background: rgba(173, 216, 230, 0.2);\n    border-color: rgba(173, 216, 230, 0.5);\n    box-shadow: 0 0 12px rgba(173, 216, 230, 0.3);\n}\n\n.shop-tab-item img {\n    width: 24px;\n    height: 24px;\n    opacity: 0.7;\n    transition: opacity 0.2s ease;\n}\n\n.shop-tab-item:hover img,\n.shop-tab-item.active img {\n    opacity: 1;\n}\n\n.shop-tab-label {\n    font-size: 14px;\n    font-weight: 500;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.shop-items-container {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n    max-width: 1024px;\n    width: 100%;\n    overflow-y: auto;\n    margin: 0 auto;\n    padding: 0 16px;\n}\n\n.shop-portrait {\n    width: 32px;\n    height: 32px;\n    margin: 10px;\n}\n\n.equipment-sections {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n    width: 100%;\n    max-width: 1024px;\n    margin: 0 auto;\n}\n\n.equipment-section {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 0 16px;\n    width: 100%;\n}\n\n.equipment-type-title {\n    color: #e0f2ff;\n    font-size: 20px;\n    font-weight: 600;\n    text-transform: uppercase;\n    padding: 8px 16px;\n    margin-bottom: 8px;\n    background: linear-gradient(90deg, rgba(173, 216, 230, 0.3), transparent);\n    border-left: 4px solid #add8e6;\n    text-shadow: 0 0 10px rgba(173, 216, 230, 0.5);\n    letter-spacing: 1px;\n    position: relative;\n    font-family: 'Kim', sans-serif;\n}\n\n.equipment-type-title::after {\n    content: '';\n    position: absolute;\n    right: 0;\n    top: 50%;\n    height: 1px;\n    width: 60%;\n    background: linear-gradient(90deg, rgba(173, 216, 230, 0.5), transparent);\n}\n\n.equipment-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n    width: 100%;\n}\n\n.shop-items-container.equipment-view {\n    display: block;\n}\n\n\n.shop-tab-item.disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    pointer-events: all;\n}\n\n.spells-container {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n    max-width: 1024px;\n    margin: 0 auto;\n}\n\n.spells-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n    width: 100%;\n}\n\n.spells-section {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 0 16px;\n    width: 100%;\n    margin-bottom: 32px;\n}\n\n.spells-type-title {\n    color: #e0f2ff;\n    font-size: 20px;\n    font-weight: 600;\n    text-transform: uppercase;\n    padding: 8px 16px;\n    margin-bottom: 8px;\n    background: linear-gradient(90deg, rgba(173, 216, 230, 0.3), transparent);\n    border-left: 4px solid #add8e6;\n    text-shadow: 0 0 10px rgba(173, 216, 230, 0.5);\n    letter-spacing: 1px;\n    position: relative;\n    font-family: 'Kim', sans-serif;\n}\n\n.spells-type-title::after {\n    content: '';\n    position: absolute;\n    right: 0;\n    top: 50%;\n    height: 1px;\n    width: 60%;\n    background: linear-gradient(90deg, rgba(173, 216, 230, 0.5), transparent);\n}\n\n.locked-spells-notice {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    padding: 24px;\n    background: rgba(173, 216, 230, 0.1);\n    border: 1px solid rgba(173, 216, 230, 0.2);\n    border-radius: 8px;\n    margin-top: 16px;\n    text-align: center;\n}\n\n.locked-spells-notice img {\n    width: 32px;\n    height: 32px;\n    opacity: 0.7;\n}\n\n.locked-spells-notice h3 {\n    color: #e0f2ff;\n    font-size: 18px;\n    margin: 0;\n}\n\n.locked-spells-notice p {\n    color: #add8e6;\n    font-size: 20px;\n    margin: 0;\n    line-height: 1.5;\n}\n\n.consumables-container {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    width: 100%;\n    max-width: 1024px;\n    margin: 0 auto;\n}\n\n.consumables-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n    width: 100%;\n}\n\n.consumables-section {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 0 16px;\n    width: 100%;\n    margin-bottom: 32px;\n}\n\n.consumables-type-title {\n    color: #e0f2ff;\n    font-size: 20px;\n    font-weight: 600;\n    text-transform: uppercase;\n    padding: 8px 16px;\n    margin-bottom: 8px;\n    background: linear-gradient(90deg, rgba(173, 216, 230, 0.3), transparent);\n    border-left: 4px solid #add8e6;\n    text-shadow: 0 0 10px rgba(173, 216, 230, 0.5);\n    letter-spacing: 1px;\n    position: relative;\n    font-family: 'Kim', sans-serif;\n}\n\n.consumables-type-title::after {\n    content: '';\n    position: absolute;\n    right: 0;\n    top: 50%;\n    height: 1px;\n    width: 60%;\n    background: linear-gradient(90deg, rgba(173, 216, 230, 0.5), transparent);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
